/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PayersApi } from '../api/payers.api';
import { switchMap, map } from 'rxjs/operators';
import { PayersData, Payers } from '../../../interfaces/masters/payers';

@Injectable()
export class PayersService extends PayersData {

  constructor(private api: PayersApi) {
    super();
  }


  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Payers>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }

  update(url: string, data:any): Observable<any> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
